const initialState = {
    embeded_url: [],
};

export const dashboardLinkReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'EmbededUrl':
            return {
                ...state,
                embeded_url: action.payload,
            };
        default:
            return state;
    }
};
